/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { GroundingMenuState, GroundingMenuSlots } from './GroundingMenu.types';

/**
 * Render the final JSX of GroundingMenu
 */
export const renderGroundingMenu_unstable = (state: GroundingMenuState): JSXElement => {
  assertSlots<GroundingMenuSlots>(state);

  // TODO Add additional slots in the appropriate place
  return <state.root />;
};
